
import { supabase, getCurrentUserId } from '../../supabase';
import { getGroups, setGroups } from './core';
import { handleApiError } from './api-utils';

export const deleteGroup = async (groupId: string): Promise<boolean> => {
  try {
    const userId = await getCurrentUserId();
    if (!userId) {
      handleApiError(
        new Error('No user ID'), 
        'deleteGroup', 
        'User not authenticated when deleting group'
      );
      return false;
    }

    const groups = getGroups();
    setGroups(groups.filter((group) => group.id !== groupId));

    const { error } = await supabase
      .from('groups')
      .delete()
      .eq('id', groupId)
      .eq('user_id', userId);

    if (error) {
      handleApiError(error, 'deleteGroup', 'Error deleting group from Supabase');
      return false;
    }

    return true;
  } catch (error: any) {
    handleApiError(error, 'deleteGroup', 'Error in deleteGroup');
    return false;
  }
};
